import { Trans } from "react-i18next";import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue } from
"../../../components/ui/select";
import { ui } from "../../../components/ui";
import { REGULARIZATION_APPROVAL_FLOWS } from "../constants/shiftFormState";

const fieldLabelClass = "block text-xs font-semibold per-file-hint mb-1.5";

const APPROVAL_FLOW_LABELS = {
  Manager: "Manager",
  HR: "HR",
  HR_Then_Manager: "HR, then Manager"
};

function YesNoToggle({ label, value, onChange }) {
  return (
    <div className="flex flex-col gap-1.5">
      <span className={fieldLabelClass}>{label}</span>
      <div className="inline-flex rounded-xl border border-(--color-text-border) p-0.5 w-fit bg-white">
        <button
          type="button"
          onClick={() => onChange(true)}
          className={`h-8 px-4 rounded-[10px] text-xs font-semibold transition ${
          value ?
          "bg-primary text-white" :
          "per-file-hint hover:text-foreground"}`
          }>
          <Trans i18nKey="common.yes" />
        
        </button>
        <button
          type="button"
          onClick={() => onChange(false)}
          className={`h-8 px-4 rounded-[10px] text-xs font-semibold transition ${
          !value ?
          "bg-primary text-white" :
          "per-file-hint hover:text-foreground"}`
          }>
          <Trans i18nKey="common.no" />
        
        </button>
      </div>
    </div>);

}

export function AttendanceControlFields({ formState, setFormState }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <YesNoToggle
        label="HR Can Mark Attendance"
        value={formState.hrCanMarkAttendance}
        onChange={(v) => setFormState((p) => ({ ...p, hrCanMarkAttendance: v }))} />
      
      <YesNoToggle
        label="HR Can Amend Time"
        value={formState.hrCanAmendTime}
        onChange={(v) => setFormState((p) => ({ ...p, hrCanAmendTime: v }))} />
      
      <YesNoToggle
        label="Mandatory Report Before Checkout"
        value={formState.mandatoryReportBeforeCheckout}
        onChange={(v) => setFormState((p) => ({ ...p, mandatoryReportBeforeCheckout: v }))} />
      

      <label className="flex flex-col gap-1.5">
        <span className={fieldLabelClass}>
          <Trans i18nKey="organizationShifts.regularizationApprovalFlow" /> <span className="text-error">*</span>
        </span>
        <Select
          value={formState.regularizationApprovalFlow}
          onValueChange={(v) => setFormState((p) => ({ ...p, regularizationApprovalFlow: v }))}>
          
          <SelectTrigger className={`${ui.input} w-full text-sm font-medium flex items-center justify-between`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {REGULARIZATION_APPROVAL_FLOWS.map((flow) =>
            <SelectItem key={flow} value={flow}>
                {APPROVAL_FLOW_LABELS[flow]}
              </SelectItem>
            )}
          </SelectContent>
        </Select>
      </label>
    </div>);

}
